<template>
  <div>
    <div class="content">
      <main>
        <div class="fullpage">
          <section>
            <div class="inner onair">
              <div class="onair-wrap">
                <div class="onair-player">
                  <div class="player-tit">{{ excsTitlNm }}</div>
                  <div class="player-frame">
                    <iframe
                      id="panoptoPlayer"
                      :src="videoSrc"
                      width="100%"
                      height="auto"
                      frameborder="0"
                      allowfullscreen />
                  </div>
                </div>
                <div class="onair-chat">
                  <div class="chat-tit-bar">
                    <div v-if="!isMock || wepApcTyp !== 'M'" class="btn-etc">
                      <button type="button" class="btn-type03 btn-s" @click.stop="fnSatisfaction('true')"><span>{{ $t('TEMPLT003') }}</span></button>
                    </div>
                    <!-- <div class="chat-tit">
                      <button type="button" class="btn-refresh" @click.stop="fnInit"><span>Refresh</span></button>
                    </div> -->
                  </div>
                  <div class="chat-frame">
                    <!-- LCPLAN-377 -->
                    <div v-if="isNotice" class="notice-area-btn">
                      <button type="button" @click="showNotice">
                        <span>Toggle Notice Area</span>
                      </button>
                    </div>
                    <!-- // LCPLAN-377 -->
                    <div v-if="isNotice" class="chat-notice">
                      <div class="notice-item">
                        <div class="notice-msg">
                          <strong class="name">{{ noticeMbrFnm }}</strong>
                          <p>
                            <span v-html="noticeCmntCntnt"/>
                          </p>
                        </div>
                        <div class="notice-btn"><button type="button" @click.prevent="openNotice"><span>Toggle Notice</span></button></div>
                      </div>
                    </div>
                    <div id="chatList" class="chat-list">
                      <div v-for="(info,index) in cmntList" :key="index" class="chat-item">
                        <div class="chat-msg">
                          <div v-if="info">
                            <div v-if=" info.uppUseYn === 'Y'">
                              <strong :class="{'admin': info.uppApcTyp === 'M' || info.uppApcTyp === 'A'}" class="name">{{ info.uppMbrFnm }} <button v-if="info.wepApcId === wepApcId || wepApcTyp === 'M' || wepApcTyp === 'A'" type="button" class="btn-type06" @click="fnCmntSnoDelete(info.cmntSno)"><span>{{ $t('WEP00043') }}</span></button></strong>
                              <p v-html="info.uppCmntCntnt"/>
                              <em>ㄴ</em><strong :class="{'admin': info.wepApcTyp === 'M' || info.wepApcTyp === 'A'}" class="name"> {{ info.mbrFnm }} </strong>
                              <p v-html="info.cmntCntnt"/>
                            </div>
                            <div v-else>
                              <strong :class="{'admin': info.wepApcTyp === 'M' || info.wepApcTyp === 'A'}" class="name">{{ info.mbrFnm }} <button type="button" class="btn-type06" @click="fnUppCmntSno(info.cmntSno)"><span>{{ $t('WEP00042') }}</span></button></strong>
                              <p v-html="info.cmntCntnt"/>
                            </div>
                          </div>
                        </div>
                        <div v-if="info && info.wepApcId === wepApcId && (info.wepApcTyp === 'M' || info.wepApcTyp === 'A')" class="chat-btn">
                          <button type="button" class="btn-alarm" @click="fnNoticeUpdate(info.cmntSno)"><span>Alarm</span></button>
                        </div>
                      </div>
                    </div>
                    <chat-input
                      v-if="isChat" ref="chatInput" :is-mock="isMock"
                      :cmnt-list="cmntList"
                      :cmnt-uuid="cmntUuid" />
                  </div>
                </div>
              </div>
              <v-runtime-template :template="includeTemplate"/>
              <div class="only-mo">
                <div class="guide-wrap">
                  <h4>{{ $t('WEP00038') }}</h4>
                  <a :href="basePath + '/guide'" target="_blank" class="guide-box">
                    <p>{{ $t('WEP00039') }}</p>
                  </a>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
    <SurveyPopup v-if="visible" @satisfaction="fnSatisfaction"/>
  </div>
</template>
<script>

import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import SurveyPopup from '~pages/contents/main/SurveyPopup.vue'
import ChatInput from '~pages/contents/main/ChatInput.vue'
// import { ref } from 'vue'
import commonUtils from '~fdp/utils/index.js'
import { isEmpty } from 'lodash'

export default {
  name: 'Classnow',
  metaInfo () {
  },
  components: {
    VRuntimeTemplate,
    SurveyPopup,
    ChatInput
  },
  data () {
    return {
      includeHtml: '',
      basePath: this.getStore('mmpAuth').state.basePath,
      visible: false,
      wepSets: this.getStore('mmpAuth').state.wepSets,
      windowObjHistorySearch: '',
      isNotice: false,
      lastCmntSno: '',
      cmntList: [], // 댓글 리스트
      tempList: [],
      cnt: 0,
      mbrFnm: '',
      noticeMbrFnm: '',
      noticeCmntCntnt: '',
      cmntCntnt: '',
      noticeCmntSno: '',
      intervalId: null,
      wepApcId: this.getStore('mmpAuth').state.session.userId,
      wepId: this.getStore('mmpAuth').state.session.wepId,
      wepApcTyp: this.getStore('mmpAuth').state.session.wepApcTyp,
      isMock: false,
      videoSrc: '',
      cmntInqrCnt: '',
      cmntRpatInqrTm: '',
      excsTitlNm: '',
      emrScCd: '',
      isChat: false,
      uppAnswSno: '',
      initCnt: 0,
      isLoading: false,
      cmntUuid: ''
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    }
  },
  mounted () {
    this.fnInit()
  },
  beforeUpdate () {
  },
  updated () {
    let chatList = document.getElementById('chatList')
    chatList.scrollTop = chatList.scrollHeight
    if (!this.isChat) {
      this.isChat = true
    }
  },
  destroyed () {
    clearInterval(this.intervalId)
  },
  async created () {
    this.cmntUuid = commonUtils.generateUID()

    let params = {
      wepId: this.wepId,
      langId: localStorage.getItem('language')
    }
    let resultInfo = await this.$http.mmp.getTzTime(this, params)
    let currDay = resultInfo.data.data

    if (this.wepSets.mocktUseYn === 'Y' && currDay >= this.wepSets.mocktStartDtm && currDay <= this.wepSets.mocktEndDtm) {
      this.isMock = true
    }

    if (this.wepSets.videoTrnsTyp === '01' ) {
      this.getTemplate('wepEnter.html', '0', 'enter')
    } else {
      if (isEmpty(wepHtmlToString.mainTemplate)) {
        this.getEmptyTemplate('wepAgenda.html')
      } else {
        this.includeHtml = wepHtmlToString.mainTemplate
      }
      this.videoSrc = this.basePath + '/panoptoPlayer'
    }
  },
  methods: {
    async fnInit () {
      // 웨비나 채팅 환경값
      if (this.tempList.length === 0) {
        let params = {
          wepId: this.wepId
        }
        let result = await this.$http.mmp.onAirCommentInfo(this, params)
        if (result.data.status === 'OK') {
          let resultInfo = result.data.data.info
          if (this.$t('TEMPLT002') === 'TEMPLT002') {
            this.excsTitlNm = resultInfo.excsTitlNm
          } else {
            this.excsTitlNm = this.$t('TEMPLT002')
          }

          this.cmntRpatInqrTm = resultInfo.cmntRpatInqrTm
          this.cmntInqrCnt = resultInfo.cmntInqrCnt

          if (this.emrScCd !== resultInfo.emrScCd) {
            if (resultInfo.emrScCd === 'PLAYER_ERROR') {
              this.emrScCd = resultInfo.emrScCd
              let alertParams = { title: this.$t('WEP00008'), contents: this.$t('WEP00045'), okBtnNm: this.$t('WEP00006'), cancelBtnNm: '' }
              let confirmRes = await this.$popup.confirm(this.$el, alertParams)
              if (confirmRes) {
                document.getElementById('panoptoPlayer').src = this.videoSrc
              }
            } else if (resultInfo.emrScCd === 'COMMENT_ERROR') {
              this.emrScCd = resultInfo.emrScCd
              let alertParams = { title: this.$t('WEP00008'), contents: this.$t('WEP00046'), okBtnNm: this.$t('WEP00006'), cancelBtnNm: '' }
              let confirmRes = await this.$popup.confirm(this.$el, alertParams)
              if (confirmRes) {
                document.getElementById('cmntCntnt').value = ''
                document.getElementById('cmntCntnt').readOnly = true
              }
            } else if (resultInfo.emrScCd === 'ALL_ERROR') {
              this.emrScCd = resultInfo.emrScCd
              let alertParams = { title: this.$t('WEP00008'), contents: this.$t('WEP00047'), okBtnNm: this.$t('WEP00006'), cancelBtnNm: '' }
              let confirmRes = await this.$popup.confirm(this.$el, alertParams)
              if (confirmRes) {
                document.getElementById('panoptoPlayer').src = this.videoSrc
                document.getElementById('cmntCntnt').value = ''
                document.getElementById('cmntCntnt').readOnly = true
              }
            } else if ((this.emrScCd === 'COMMENT_ERROR' || this.emrScCd === 'ALL_ERROR') && resultInfo.emrScCd === null) {
              this.emrScCd = resultInfo.emrScCd
              let alertParams = { title: this.$t('WEP00008'), contents: this.$t('WEP00048'), okBtnNm: this.$t('WEP00006'), cancelBtnNm: '' }
              let confirmRes = await this.$popup.confirm(this.$el, alertParams)
              if (confirmRes) {
                document.getElementById('cmntCntnt').readOnly = false
              }
            } else {
              this.emrScCd = resultInfo.emrScCd
            }
          }
          // this.emrScCd = resultInfo.emrScCd
          if (this.lastCmntSno === '') {
            this.lastCmntSno = resultInfo.lastCmntSno
          }
        }
        this.fnReLoad()
      } else {
        this.fnLoad()
      }
    },
    async fnReLoad () {
      // 댓글 API 호출
      let params = {
        wepApcId: this.wepApcId,
        wepId: this.wepId,
        lastCmntSno: this.lastCmntSno,
        cmntUuid: this.cmntUuid
      }
      let result = await this.$http.mmp.onAirComment(this, params)
      if (result.data.status === 'OK') {
        this.tempList = result.data.data.list
        if (this.tempList.length > 0) {
          this.$nextTick(function () {
            this.fnLoad()
            this.getNotice(result)
          })
        } else {
          this.$nextTick(function () {
            clearInterval(this.intervalId)
            this.startTimer()
            this.getNotice(result)
          })
        }
      }
    },
    async fnLoad () {
      // 댓글 LOAD
      let key = 0
      // let wepApcId = ''
      let cnt = 20
      for (key in this.tempList) {
        let info = this.tempList[key]
        // wepApcId = info.wepApcId
        this.lastCmntSno = info.cmntSno

        // if (this.cmntList.length !== 0) {
        //  continue
        // }
        if (this.initCnt === 0) { // } && wepApcId !== this.wepApcId) {
          this.cmntList.push(info)
        } else { // } if (wepApcId !== this.wepApcId) {
          this.cmntList.push(info)
          cnt--
          if (cnt === 0) {
            break
          }
        }
      }
      this.initCnt = 20
      this.tempList.splice(0, ++key)

      if (this.cmntList.length > this.cmntInqrCnt) {
        let removeCnt = this.cmntList.length - this.cmntInqrCnt
        this.cmntList.splice(0, removeCnt)
      }
      this.$nextTick(function () {
        clearInterval(this.intervalId)
        this.startTimer()
      })
    },
    async fnUppCmntSno (uppAnswSno) {
      this.$refs.chatInput.fnUppCmntSno(uppAnswSno)
    },
    async fnCmntSnoDelete (cmntSno) {
      let params = {
        cmntSno: cmntSno,
        wepId: this.wepId,
        wepApcId: this.wepApcId
      }

      let result = await this.$http.mmp.onAirCommentDelete(this, params)
      if (result.data.status !== 'OK') {
        this.commAlert(this.$t('WEP00027'))
      } else {
        let index = this.cmntList.findIndex(x => x.cmntSno === cmntSno)
        this.cmntList.splice(index, 1)
      }
    },
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.mainTemplate = res
        this.includeHtml = wepHtmlToString.mainTemplate
      })
    },
    openNotice () {
      document.querySelectorAll('.notice-item')[0].classList.toggle('opened')
    },
    async fnSatisfaction (arg) {
      if (arg) {
        // 평가유무 확인
        let params = {
          survyScCd: '02',
          wepApcId: this.wepApcId
        }
        this.cmntCntnt = document.getElementById('cmntCntnt').value
        let resultInfo = await this.$http.mmp.evalSurveyYn(this, params)
        if (resultInfo.data.status !== 'OK') {
          this.commAlert(this.$t('WEP00027'))
        } else {
          if (resultInfo.data.data.evalYn === 'N') {
            this.visible = arg
            this.setOverflow(this.visible)
          } else {
            this.commAlert(this.$t('WEP00026'))
          }
        }
      } else {
        this.visible = arg
        this.setOverflow(this.visible)
      }
    },
    async fnNoticeUpdate (cmntSno) {
      let params = {
        wepApcId: this.wepApcId,
        wepId: this.wepId,
        cmntSno: cmntSno,
        lastCmntSno: this.lastCmntSno
      }
      this.cmntCntnt = document.getElementById('cmntCntnt').value
      let result = await this.$http.mmp.onAirNoticeUpdate(this, params)
      this.getNotice(result)
    },
    async getNotice (result) {
      let info = result.data.data.info
      if (info != null) {
        if (info.noticeMbrFnm !== '' && info.noticeCmntCntnt !== '' && info.noticeCmntSno !== this.noticeCmntSno) {
          this.noticeMbrFnm = info.mbrFnm
          this.noticeCmntCntnt = info.cmntCntnt
          this.isNotice = true
          this.cmntSno = info.noticeCmntSno
          this.fnClientHeight()
        } else {
          this.isNotice = false
          this.noticeCmntSno = ''
        }
      }
    },
    async startTimer () {
      this.intervalId = setInterval(() => {
        this.fnInit()
      }, this.cmntRpatInqrTm)
    },
    async fnClientHeight () {
      setTimeout(function () {
        if (document.querySelectorAll('.notice-msg > p > span')[0].clientHeight !== null) {
          const clientHeight = document.querySelectorAll('.notice-msg > p > span')[0].clientHeight
          const msgBtn = document.querySelectorAll('.notice-btn')[0]
          if (clientHeight <= 40) {
            msgBtn.classList.add('only-mo')
          } else {
            msgBtn.classList.remove('only-mo')
          }
        }
      }, 800)
    },
    fnInquiryPopup () {
      this.$emit('fnInquiryPopup')
    },
    showNotice () {
      document.querySelectorAll('.chat-frame')[0].classList.toggle('closed')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/Classnow.vue